export function ReportBuilderStepper({ steps, activeStep, stepIndex, onStepClick, c, A }) {
  return (
    <div
      role="tablist"
      aria-label="Report builder progress"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 0,
        padding: "4px 0",
        overflowX: "auto",
        flex: 1,
        minWidth: 0,
      }}
    >
      {steps.map((step, i) => {
        const active = step.id === activeStep;
        const done = i < stepIndex;
        const connectorDone = i < stepIndex;

        return (
          <div key={step.id} style={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            <button
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onStepClick(step.id)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 10px",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                background: active ? `${A}18` : "transparent",
                color: active ? c.text : done ? c.mid : c.sub,
                fontSize: 12,
                fontWeight: active ? 700 : 600,
                whiteSpace: "nowrap",
              }}
              onMouseEnter={(e) => {
                if (!active) e.currentTarget.style.background = c.hover;
              }}
              onMouseLeave={(e) => {
                if (!active) e.currentTarget.style.background = active ? `${A}18` : "transparent";
              }}
            >
              <span
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 10,
                  fontWeight: 700,
                  background: active || done ? A : c.hover,
                  color: active || done ? "#fff" : c.sub,
                  flexShrink: 0,
                }}
              >
                {done && !active ? "✓" : i + 1}
              </span>
              {step.label}
            </button>
            {i < steps.length - 1 ? (
              <div
                style={{
                  width: 20,
                  height: 2,
                  background: connectorDone ? A : c.divider,
                  margin: "0 2px",
                  borderRadius: 1,
                  flexShrink: 0,
                }}
              />
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
